var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DETAILS-LIST"},[_vm._t("default",function(){return _vm._l((_vm.items),function(item){return _c('detail-item',{key:item.label,attrs:{"item-label":item.label,"item-value":item.value,"item-selenium":item.selenium}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }